import {
  type Pagination,
  type Project,
  type ProjectCopilotConfiguration,
  ProjectStatus,
  type ProjectWithRelations,
  type SearchProjects,
  type SearchProjectsOrderBy,
  type UserProfile,
} from '@factoryfixinc/ats-interfaces';

// Local shadow of SearchProjects: `prioritizeCopilot` (sort active/copilot jobs first)
// is a backend query flag that ats-interfaces does not expose, so it is declared here.
export type ProjectSearchQuery = Partial<SearchProjects> & { prioritizeCopilot?: boolean };

export type SearchProjectsInput = {
  employerId: number;
  search?: ProjectSearchQuery;
};

export type GetEmployerLocationsInput = {
  employerId: number;
};

export type GetEmployerLocationsOutput = {
  locations: string[];
};

export type UpdateProjectInput = {
  title?: string;
  location?: string;
  generateQueryForSavedSearch?: boolean;
  scheduledUpdates?: boolean;
  projectCopilotConfiguration?: Pick<
    ProjectCopilotConfiguration,
    'version' | 'snapshot' | 'copilotConfigurationTemplateId'
  >;
};

export type DuplicateProjectInput = {
  title?: string;
  location?: string;
};

export type CreateProjectInput = {
  title: string;
  location: string;
  activeOutreachEnabled?: boolean;
};

// This will be removed once Fernando updates ats-interfaces
export enum OrderByFields {
  UPDATE_TS = 'updateTs',
  TITLE = 'title',
}

export enum ProjectFilterTab {
  MY_JOBS = 'my_jobs',
  ALL_JOBS = 'all_jobs',
}

export interface SearchProjectsOutput {
  projects: ProjectWithRelations<'candidates'>[];
  total: number;
}

export {
  ProjectStatus,
  type Project,
  type SearchProjects,
  type ProjectWithRelations,
  type Pagination,
  type UserProfile,
  type SearchProjectsOrderBy,
};
